module.exports = __webpack_public_path__ + "static/img/p5.0e8158c7.png";